import { SettingsProfile, SettingsEmailNotifications, SettingsPayments, SettingsAssistants } from "@/components/pages/Client/settings";
import { FavouriteDrivers, FavouriteGuests, FavouriteLocations } from "@/components/pages/MyFavourites";
import { ManageClient as ManageClientLayout } from "./ManageClient";
import { ManageClientDetails } from "./details/ManageClientDetails";
import { ManageClientEaClients } from "./eaClients/ManageClientEaClients";
import { ManageClientFavourites } from "./favourites/ManageClientFavourites";
import { AdminSettings } from "./settings/AdminSettings";
import { ManageClientSettings } from "./settings/ManageClientSettings";

export const ManageClient = Object.assign(ManageClientLayout, {
  Details: ManageClientDetails,
  // Executive Assistant / Travel Manager only — the EA's managed-client list, view-only
  // (the "Remove My Access" affordance is hidden in this operator context).
  EaClients: ManageClientEaClients,
  // Favourites layout + its sub-screens (reused client favourites tables, client-scoped
  // via ClientScopeProvider — the tables read useClientScope() and thread accountId).
  Favourites: Object.assign(ManageClientFavourites, {
    Locations: FavouriteLocations,
    Guests: FavouriteGuests,
    Drivers: FavouriteDrivers,
  }),
  // Settings layout + its sub-screens (reused, client-scoped via ClientScopeProvider).
  Settings: Object.assign(ManageClientSettings, {
    Profile: SettingsProfile,
    Notifications: SettingsEmailNotifications,
    Payments: SettingsPayments,
    // View + remove only for operators — approve/decline stays the client's own consent (SettingsAssistants
    // reads useClientScope() and hides the approval affordances when scoped to a managed client).
    Assistants: SettingsAssistants,
    // Operator-only — no client self-service equivalent.
    AdminSettings: AdminSettings,
  }),
});

export { useManageClient } from "./context";
export { OperatorClientBooking } from "./booking/OperatorClientBooking";
export { OperatorClientBookingConfirmation } from "./booking/OperatorClientBookingConfirmation";
